import { render, staticRenderFns } from "./option.vue?vue&type=template&id=0b55e2a7&"
import script from "./option.vue?vue&type=script&lang=js&"
export * from "./option.vue?vue&type=script&lang=js&"
import style0 from "./option.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports